import React from 'react';
import PropTypes from 'prop-types';

import Kinostyles from '../../Util/LandingPageStylesComponent.module.css';

const CTAButton = props => {
  const { url, text, centered, color } = props;

  const getColorClass = () => {
    switch (color) {
      case 'pink':
        return Kinostyles.CTAButtonNew;
      case 'green':
        return Kinostyles.CTAButtonNewGreen;
      case 'black':
        return Kinostyles.CTAButtonNewBlack;
      default:
        return Kinostyles.CTAButtonNew;
    }
  };

  const getTextColorClass = () => {
    switch (color) {
      case 'pink':
        return Kinostyles.CTAButtonLinkNew;
      case 'green':
        return Kinostyles.CTAButtonLinkNewGreen;
      case 'black':
        return Kinostyles.CTAButtonLinkNewBlack;
      default:
        return Kinostyles.CTAButtonLinkNew;
    }
  };

  return (
    <div>
      {centered ? (
        <div className={Kinostyles.CenterContent}>
          <button className={getColorClass()}>
            <a href={url} className={getTextColorClass()}>
              {text}
            </a>
          </button>
        </div>
      ) : (
        <button className={getColorClass()}>
          <a href={url} className={getTextColorClass()}>
            {text}
          </a>
        </button>
      )}
    </div>
  );
};

CTAButton.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  centered: PropTypes.bool,
};

export default CTAButton;
